import type AccountWorkflowView from '@UI/Store/SubjectTypeDefinitions/Views/AccountWorkflowView';

/** The workflows of an account, in the served order (sorted by label). */
class AccountWorkflowsView {
	readonly accountId: number;
	readonly list: readonly AccountWorkflowView[];

	constructor(list: readonly AccountWorkflowView[], accountId: number) {
		this.list = list;
		this.accountId = accountId;

		Object.freeze(this);
	}

	findByKey(key: string): AccountWorkflowView | null {
		return this.list.find((workflow) => workflow.key === key) ?? null;
	}
}

export default AccountWorkflowsView;
